"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlobConfigDeprecatedError = exports.DEPRECATED_APP_BASE_CONFIG_BLOB_FIELDS = exports.AppBaseConfigSchema = exports.AppBasePendingDatabaseAttachmentSchema = exports.AppBaseAttachCreateColumnSchema = exports.AppBaseSourceFileRowSchema = exports.StyleVariantSchema = exports.StyleVariantMediaSchema = exports.StyleVariantStateSchema = exports.StylePresetSchema = exports.StyleTokenValueSchema = exports.StyleTokenNameSchema = exports.ContentRhythmSchema = exports.CtaTreatmentSchema = exports.TypographyScaleSchema = exports.MediaTreatmentSchema = exports.StyleRadiusSchema = exports.StyleElevationSchema = exports.StyleDensitySchema = exports.StyleSurfaceSchema = exports.StylePresetTargetSchema = exports.MotionSpecSchema = exports.ReducedMotionPolicySchema = exports.MotionEasingSchema = exports.MotionPresetSchema = exports.MotionTriggerSchema = exports.TranslationEntrySchema = exports.NavigationItemSchema = exports.PageDefinitionSchema = exports.DataSourceRegistrySchema = exports.DataSourceRefSchema = exports.AppBaseBrandingSettingsSchema = exports.AppBaseBrandingSocialImageSourceSchema = exports.AppBaseBrandingFaviconSourceSchema = exports.AppBaseBrandingLogoSourceSchema = exports.INITIAL_APP_BASE_CONTENT_MODEL_BY_ROLE = exports.DEFAULT_APP_BASE_CONTENT_MODEL_BY_ROLE = exports.AppBaseContentModelSchema = exports.APP_BASE_ATTACHABLE_DATABASE_ROLES = exports.STANDARD_APP_BASE_DATABASE_ROLES = exports.APP_BASE_DATA_SOURCE_KEYS = exports.AppBaseDataSourceRoleSchema = exports.StandardDatabaseRoleSchema = exports.AppBasePageStatusSchema = exports.PublicationModelSchema = exports.AppBasePortalSettingsSchema = exports.AudienceSchema = exports.RouteKindSchema = exports.DATA_SOURCE_REF_SCHEMA_VERSION = exports.APP_BASE_CONFIG_SCHEMA_VERSION = void 0;
exports.isAttachableAppBaseDatabaseRole = isAttachableAppBaseDatabaseRole;
exports.getDefaultAppBaseContentModelForRole = getDefaultAppBaseContentModelForRole;
exports.getInitialAppBaseContentModelForRole = getInitialAppBaseContentModelForRole;
exports.createAppBaseDataSourceKey = createAppBaseDataSourceKey;
exports.validateNoDeprecatedBlobFields = validateNoDeprecatedBlobFields;
exports.withRowOwnedAppBaseState = withRowOwnedAppBaseState;
exports.isReplaceableAppPlaceholderPage = isReplaceableAppPlaceholderPage;
exports.isReplaceableAppPlaceholderRoute = isReplaceableAppPlaceholderRoute;
exports.planAppRemoval = planAppRemoval;
exports.planTrashedAppRemoval = planTrashedAppRemoval;
exports.appPageAccessRoutes = appPageAccessRoutes;
exports.sanitizeAppManifestForMarketplaceExport = sanitizeAppManifestForMarketplaceExport;
exports.sanitizeAppBaseConfigForMarketplaceAppExport = sanitizeAppBaseConfigForMarketplaceAppExport;
exports.createDefaultDataSourceRef = createDefaultDataSourceRef;
exports.createAppBaseDatabaseBindingsFromDataSources = createAppBaseDatabaseBindingsFromDataSources;
exports.projectAppBaseDatabaseBindingDataSources = projectAppBaseDatabaseBindingDataSources;
exports.listAppBaseSourceDeclarations = listAppBaseSourceDeclarations;
exports.canProvisionAppBaseSource = canProvisionAppBaseSource;
exports.resolveAppBaseRowGroupInsertTarget = resolveAppBaseRowGroupInsertTarget;
exports.appBaseRowGroupInsertTableDenial = appBaseRowGroupInsertTableDenial;
exports.appActionTableOperations = appActionTableOperations;
exports.appActionHostOnly = appActionHostOnly;
exports.appActionHostDecision = appActionHostDecision;
exports.appActionWithoutPageAllowed = appActionWithoutPageAllowed;
exports.appPagePublicActsAsPortal = appPagePublicActsAsPortal;
exports.appPageActionDecision = appPageActionDecision;
exports.appActionWidestPrincipalType = appActionWidestPrincipalType;
exports.withAppBaseDatabaseBinding = withAppBaseDatabaseBinding;
exports.withPendingDatabaseAttachment = withPendingDatabaseAttachment;
exports.withoutAppBaseDatabaseBinding = withoutAppBaseDatabaseBinding;
exports.withMovedAppBaseDatabaseBinding = withMovedAppBaseDatabaseBinding;
exports.createDefaultAppBaseConfig = createDefaultAppBaseConfig;
exports.createAppBaseConfigFromContentDbRef = createAppBaseConfigFromContentDbRef;
exports.resolveDataSourceRegistry = resolveDataSourceRegistry;
exports.resolveAppBaseBindingDataSources = resolveAppBaseBindingDataSources;
exports.resolveAppBaseDatabaseBindings = resolveAppBaseDatabaseBindings;
exports.createAppBaseAppBaseConfig = createAppBaseAppBaseConfig;
const zod_1 = require("zod");
const app_base_column_map_1 = require("./app-base-column-map");
const app_base_contract_1 = require("./app-base-contract");
const app_base_locales_1 = require("./app-base-locales");
const app_page_access_1 = require("./app-page-access");
const content_i18n_1 = require("./content-i18n");
const formula_1 = require("./formula");
const publication_contract_1 = require("./publication-contract");
exports.APP_BASE_CONFIG_SCHEMA_VERSION = 1;
exports.DATA_SOURCE_REF_SCHEMA_VERSION = 2;
exports.RouteKindSchema = zod_1.z.enum([
    'static',
    'index',
    'detail',
    'form',
    'dashboard',
    'custom',
]);
exports.AudienceSchema = zod_1.z.enum([
    'public',
    'members',
    'internal',
    'portal',
]);
/**
 * Portal authoring policy stored with the AppBase draft and copied into
 * published snapshots. Absence means the historical open-registration
 * behaviour, so existing portal apps keep working until an editor changes it.
 */
exports.AppBasePortalSettingsSchema = zod_1.z.object({
    registrationEnabled: zod_1.z.boolean(),
});
exports.PublicationModelSchema = zod_1.z.enum([
    'evergreen',
    'timestamped',
    'versioned',
    'submission',
]);
exports.AppBasePageStatusSchema = publication_contract_1.PublicationStatusSchema;
exports.StandardDatabaseRoleSchema = zod_1.z.enum([
    'config',
    'branding',
    'clusters',
    'topics',
    'users',
    'content',
    'translations',
    'forms',
    'submissions',
    // sl-sbux.8.1: database-native styling roles. Themes/MotionSpecs/
    // StylePresets/StyleVariants/CustomSheets/CustomHtmlBlocks replace the
    // legacy `ViewConfig.payload.{motion,styles,styleVariants,theme.customCss}`
    // blob fields. StyleVariants gets its own role (sl-sbux.8.1 amendment
    // 2026-05-23) because each variant has an independent CRUD lifecycle
    // and a many-to-one relation back to its preset.
    'themes',
    'motionSpecs',
    'stylePresets',
    'styleVariants',
    'customSheets',
    'customHtmlBlocks',
    // Page texts by key: every row is delivered, no publication status.
    'texts',
]);
exports.AppBaseDataSourceRoleSchema = zod_1.z.enum([
    'branding',
    'clusters',
    'topics',
    'users',
    'content',
    'translations',
    'forms',
    'submissions',
    'themes',
    'motionSpecs',
    'stylePresets',
    'styleVariants',
    'customSheets',
    'customHtmlBlocks',
    // Page texts by key: every row is delivered, no publication status.
    'texts',
]);
exports.APP_BASE_DATA_SOURCE_KEYS = {
    BRANDING: 'branding',
    CLUSTERS: 'clusters',
    TOPICS: 'topics',
    USERS: 'users',
    CONTENT: 'content',
    TRANSLATIONS: 'translations',
    FORMS: 'forms',
    SUBMISSIONS: 'submissions',
    THEMES: 'themes',
    MOTION_SPECS: 'motionSpecs',
    STYLE_PRESETS: 'stylePresets',
    STYLE_VARIANTS: 'styleVariants',
    CUSTOM_SHEETS: 'customSheets',
    CUSTOM_HTML_BLOCKS: 'customHtmlBlocks',
    TEXTS: 'texts',
};
exports.STANDARD_APP_BASE_DATABASE_ROLES = [
    'branding',
    'clusters',
    'topics',
    'users',
    'content',
    'translations',
    'forms',
    'submissions',
    'themes',
    'motionSpecs',
    'stylePresets',
    'styleVariants',
    'customSheets',
    'customHtmlBlocks',
    'texts',
];
exports.APP_BASE_ATTACHABLE_DATABASE_ROLES = [
    'content',
    'users',
    'clusters',
    'topics',
];
/**
 * Whether an existing workspace table may take the role in an App Container:
 * the roles any table may take, and every role of a table an App places in
 * the workspace to share it between App Containers.
 */
function isAttachableAppBaseDatabaseRole(role, placement) {
    return (placement === 'workspace' ||
        exports.APP_BASE_ATTACHABLE_DATABASE_ROLES.includes(role));
}
exports.AppBaseContentModelSchema = zod_1.z.enum([
    'app-base-branding',
    'app-base-cluster',
    'app-base-topic',
    'app-base-user',
    'landing-content',
    'legal-page',
    'news-article',
    'intranet-dashboard-item',
    'workflow-form',
    'workflow-submission',
    'development-demand',
    'development-epic',
    'development-work-item',
    'development-agent',
    'development-release',
    'development-release-event',
    'development-system',
    'development-decision',
    'translation-entry',
    'app-base-theme',
    'motion-spec',
    'style-preset',
    'style-variant',
    'custom-sheet',
    'custom-html-block',
    'page-text',
]);
exports.DEFAULT_APP_BASE_CONTENT_MODEL_BY_ROLE = {
    branding: 'app-base-branding',
    clusters: 'app-base-cluster',
    topics: 'app-base-topic',
    users: 'app-base-user',
    content: 'landing-content',
    translations: 'translation-entry',
    forms: 'workflow-form',
    submissions: 'workflow-submission',
    themes: 'app-base-theme',
    motionSpecs: 'motion-spec',
    stylePresets: 'style-preset',
    styleVariants: 'style-variant',
    customSheets: 'custom-sheet',
    customHtmlBlocks: 'custom-html-block',
    texts: 'page-text',
};
exports.INITIAL_APP_BASE_CONTENT_MODEL_BY_ROLE = {
    ...exports.DEFAULT_APP_BASE_CONTENT_MODEL_BY_ROLE,
};
function getDefaultAppBaseContentModelForRole(role) {
    return exports.DEFAULT_APP_BASE_CONTENT_MODEL_BY_ROLE[role];
}
function getInitialAppBaseContentModelForRole(role) {
    return exports.INITIAL_APP_BASE_CONTENT_MODEL_BY_ROLE[role];
}
function createAppBaseDataSourceKey(input) {
    return input.contentModel === getDefaultAppBaseContentModelForRole(input.role)
        ? input.role
        : `${input.role}:${input.contentModel}`;
}
exports.AppBaseBrandingLogoSourceSchema = zod_1.z.enum(['workspace', 'custom']);
exports.AppBaseBrandingFaviconSourceSchema = zod_1.z.enum(['logo', 'custom']);
exports.AppBaseBrandingSocialImageSourceSchema = zod_1.z.enum([
    'logo',
    'custom',
]);
exports.AppBaseBrandingSettingsSchema = zod_1.z
    .object({
    brandingId: zod_1.z.string().min(1),
    displayName: zod_1.z.string().min(1).nullable().optional(),
    logoSource: exports.AppBaseBrandingLogoSourceSchema,
    logoBlobId: zod_1.z.string().min(1).nullable().optional(),
    faviconSource: exports.AppBaseBrandingFaviconSourceSchema,
    faviconBlobId: zod_1.z.string().min(1).nullable().optional(),
    socialImageSource: exports.AppBaseBrandingSocialImageSourceSchema.optional(),
    socialImageBlobId: zod_1.z.string().min(1).nullable().optional(),
    updatedAt: zod_1.z.string().min(1).nullable().optional(),
})
    .strict();
exports.DataSourceRefSchema = zod_1.z
    .object({
    version: zod_1.z.literal(exports.DATA_SOURCE_REF_SCHEMA_VERSION),
    key: zod_1.z.string().min(1),
    semanticKey: zod_1.z.string().min(1).optional(),
    role: exports.AppBaseDataSourceRoleSchema,
    contentModel: exports.AppBaseContentModelSchema,
    databaseId: zod_1.z.string().min(1),
    docId: zod_1.z.string().min(1),
    blockId: zod_1.z.string().min(1),
    label: zod_1.z.string().min(1),
})
    .strict();
exports.DataSourceRegistrySchema = zod_1.z.record(zod_1.z.string().min(1), exports.DataSourceRefSchema);
exports.PageDefinitionSchema = zod_1.z
    .object({
    id: zod_1.z.string().min(1),
    routeKind: exports.RouteKindSchema,
    templateKey: zod_1.z.string().min(1),
    collectionRole: zod_1.z.string().min(1).nullable(),
    publicationModel: exports.PublicationModelSchema,
    status: exports.AppBasePageStatusSchema,
    path: zod_1.z.string().min(1),
    parentPageId: zod_1.z.string().min(1).nullable().optional(),
    order: zod_1.z.number().int().nonnegative().optional(),
    titleFormula: formula_1.FormulaSchema.nullable().optional(),
    seoIndexing: zod_1.z.boolean().optional(),
    dataSourceKeys: zod_1.z.array(zod_1.z.string().min(1)),
    navigationKey: zod_1.z.string().min(1).nullable().optional(),
    i18nPolicy: content_i18n_1.ContentI18nPolicySchema.optional(),
    rowSelection: app_base_contract_1.AppBaseFixedRowSelectionSchema.optional(),
})
    .strict();
exports.NavigationItemSchema = zod_1.z.object({
    id: zod_1.z.string().min(1),
    labelFormula: formula_1.FormulaSchema.nullable().optional(),
    labelsI18n: zod_1.z.record(zod_1.z.string().min(1), zod_1.z.string().min(1)).optional(),
    pageId: zod_1.z.string().min(1).nullable().optional(),
    href: zod_1.z.string().min(1).nullable().optional(),
    parentId: zod_1.z.string().min(1).nullable().optional(),
    order: zod_1.z.number().int().nonnegative(),
});
exports.TranslationEntrySchema = content_i18n_1.ContentTranslationEntrySchema;
exports.MotionTriggerSchema = zod_1.z.enum([
    'none',
    'on-enter',
    'on-hover',
    'on-click',
]);
exports.MotionPresetSchema = zod_1.z.enum([
    'none',
    'fade-in',
    'slide-up',
    'slide-down',
    'slide-left',
    'slide-right',
    'scale-in',
    'blur-in',
    'reveal',
]);
exports.MotionEasingSchema = zod_1.z.enum([
    'linear',
    'ease',
    'ease-in',
    'ease-out',
    'ease-in-out',
    'standard',
    'emphasized',
]);
exports.ReducedMotionPolicySchema = zod_1.z.enum(['preserve', 'fade', 'static']);
exports.MotionSpecSchema = zod_1.z.object({
    id: zod_1.z.string().min(1),
    trigger: exports.MotionTriggerSchema,
    preset: exports.MotionPresetSchema,
    durationMs: zod_1.z.number().int().min(0).max(5000),
    delayMs: zod_1.z.number().int().min(0).max(5000),
    staggerMs: zod_1.z.number().int().min(0).max(1000).default(0),
    easing: exports.MotionEasingSchema,
    reducedMotionPolicy: exports.ReducedMotionPolicySchema,
});
exports.StylePresetTargetSchema = zod_1.z.enum([
    'section',
    'hero',
    'card',
    'form',
    'panel',
]);
exports.StyleSurfaceSchema = zod_1.z.enum([
    'quiet',
    'raised',
    'editorial',
    'form',
    'inset',
]);
exports.StyleDensitySchema = zod_1.z.enum(['compact', 'standard', 'spacious']);
exports.StyleElevationSchema = zod_1.z.enum(['none', 'sm', 'md']);
exports.StyleRadiusSchema = zod_1.z.enum(['none', 'sm', 'md']);
exports.MediaTreatmentSchema = zod_1.z.enum([
    'none',
    'thumbnail',
    'cover',
    'wide',
]);
exports.TypographyScaleSchema = zod_1.z.enum(['compact', 'body', 'display']);
exports.CtaTreatmentSchema = zod_1.z.enum(['link', 'button', 'quiet']);
exports.ContentRhythmSchema = zod_1.z.enum(['tight', 'normal', 'generous']);
exports.StyleTokenNameSchema = zod_1.z.enum([
    'surface',
    'padding',
    'gap',
    'radius',
    'shadow',
    'mediaRatio',
    'fontScale',
    'ctaRadius',
]);
exports.StyleTokenValueSchema = zod_1.z.enum([
    'none',
    'quiet',
    'raised',
    'editorial',
    'form',
    'inset',
    'compact',
    'standard',
    'spacious',
    'sm',
    'md',
    'thumbnail',
    'cover',
    'wide',
    'body',
    'display',
    'link',
    'button',
    'generous',
]);
exports.StylePresetSchema = zod_1.z.object({
    id: zod_1.z.string().min(1),
    target: exports.StylePresetTargetSchema,
    surface: exports.StyleSurfaceSchema,
    density: exports.StyleDensitySchema,
    elevation: exports.StyleElevationSchema,
    radius: exports.StyleRadiusSchema,
    mediaTreatment: exports.MediaTreatmentSchema,
    typographyScale: exports.TypographyScaleSchema,
    ctaTreatment: exports.CtaTreatmentSchema,
    contentRhythm: exports.ContentRhythmSchema,
});
exports.StyleVariantStateSchema = zod_1.z.enum(['hover', 'focus', 'active']);
exports.StyleVariantMediaSchema = zod_1.z.enum([
    'base',
    'mobile',
    'desktop',
    'reduced-motion',
]);
exports.StyleVariantSchema = zod_1.z.object({
    id: zod_1.z.string().min(1),
    presetId: zod_1.z.string().min(1),
    state: exports.StyleVariantStateSchema.nullable().optional(),
    media: exports.StyleVariantMediaSchema,
    tokens: zod_1.z.partialRecord(exports.StyleTokenNameSchema, exports.StyleTokenValueSchema),
});
/** One source file of an App: an ordinary attachment row of the files table. */
exports.AppBaseSourceFileRowSchema = zod_1.z.object({
    appId: zod_1.z.string().min(1),
    path: zod_1.z.string().min(1),
    sha256: zod_1.z.string().regex(/^[a-f0-9]{64}$/),
    blobId: zod_1.z.string().min(1),
});
/**
 * sl-sbux.8.2 B4: motion/styles/styleVariants moved out of AppBaseConfig into
 * dedicated standard databases (motionSpecs, stylePresets, styleVariants).
 * Raw `AppBaseConfig` blobs that still carry these legacy fields are rejected
 * fail-loud by {@link validateNoDeprecatedBlobFields} BEFORE Zod runs, so
 * stale persisted payloads surface a `BlobConfigDeprecatedError` instead of
 * silently shedding data through `.strip()`.
 */
/** An App column an approval adds to the table before it binds. */
exports.AppBaseAttachCreateColumnSchema = zod_1.z
    .object({
    columnId: zod_1.z.string().min(1).max(256),
    name: zod_1.z.string().max(512),
    type: zod_1.z.string().min(1).max(64),
    data: zod_1.z.record(zod_1.z.string().min(1), zod_1.z.unknown()).optional(),
})
    .strict();
/**
 * A workspace table an install may not bind: the binding it would have made
 * and the App columns it would have added, asked of the table's manager. No
 * binding means no access; only the checks of the App know the key, and a
 * read of it says it waits for approval. The approval binds and drops it.
 */
exports.AppBasePendingDatabaseAttachmentSchema = zod_1.z
    .object({
    databaseId: zod_1.z.string().min(1).max(256),
    docId: zod_1.z.string().min(1).max(256),
    blockId: zod_1.z.string().min(1).max(256),
    label: zod_1.z.string().max(512),
    role: exports.AppBaseDataSourceRoleSchema.optional(),
    contentModel: exports.AppBaseContentModelSchema.optional(),
    columnIds: zod_1.z.array(zod_1.z.string().min(1).max(256)).max(512),
    columnMap: zod_1.z
        .record(zod_1.z.string().min(1), zod_1.z.string().min(1).max(256))
        .optional(),
    rowLimit: zod_1.z.number().int().positive().optional(),
    semanticKey: zod_1.z.string().min(1).max(256).optional(),
    createColumns: zod_1.z.array(exports.AppBaseAttachCreateColumnSchema).max(512),
})
    .strict();
const AppBaseConfigShapeSchema = zod_1.z.object({
    schemaVersion: zod_1.z.literal(exports.APP_BASE_CONFIG_SCHEMA_VERSION),
    productMode: app_base_contract_1.AppBaseProductModeSchema.optional(),
    /** Page rights per audience (epc-arm-1-vertrag); see app-page-access. */
    pageAccess: app_page_access_1.AppPageAccessSectionSchema.optional(),
    defaultLocale: app_base_locales_1.AppBaseLocaleSchema,
    availableLocales: zod_1.z.array(app_base_locales_1.AppBaseLocaleSchema).min(1),
    dataSources: zod_1.z.unknown().optional(),
    databaseBindings: app_base_contract_1.AppBaseDatabaseBindingRegistrySchema,
    /** By App source key; see {@link AppBasePendingDatabaseAttachmentSchema}. */
    pendingDatabaseAttachments: zod_1.z
        .record(zod_1.z.string().min(1), exports.AppBasePendingDatabaseAttachmentSchema)
        .optional(),
    appComposition: app_base_contract_1.AppCompositionSchema.optional(),
    /** Workspace-owned definitions; Marketplace is provenance, never runtime. */
    appDefinitions: zod_1.z.record(zod_1.z.string(), app_base_contract_1.AppDefinitionSchema).prefault({}),
    /** Platform-owned association with ordinary attachment cells, not a table contract. */
    sourceFiles: zod_1.z
        .object({
        docId: zod_1.z.string().min(1),
        databaseId: zod_1.z.string().min(1),
        columnId: zod_1.z.string().min(1),
        rows: zod_1.z.record(zod_1.z.string(), exports.AppBaseSourceFileRowSchema),
    })
        .optional(),
    appBase: app_base_contract_1.AppManifestSchema.optional(),
    appArtifact: app_base_contract_1.AppArtifactSchema.optional(),
    appBaseLifecycle: app_base_contract_1.AppBaseLifecycleSchema.optional(),
    pages: zod_1.z.array(exports.PageDefinitionSchema),
    navigation: zod_1.z.array(exports.NavigationItemSchema),
    i18nPolicy: content_i18n_1.ContentI18nPolicySchema.optional(),
    stripImageMetadata: zod_1.z.boolean().default(true),
    portalSettings: exports.AppBasePortalSettingsSchema.optional(),
});
function validateAppBaseDataSourceProjection(appBaseConfig, ctx) {
    if (appBaseConfig.dataSources !== undefined) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ['dataSources'],
            message: 'App dataSources is derived from databaseBindings and must not be persisted',
        });
    }
    appBaseConfig.pages.forEach((page, pageIndex) => {
        if (page.rowSelection &&
            !page.dataSourceKeys.includes(page.rowSelection.sourceKey)) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                path: ['pages', pageIndex, 'rowSelection', 'sourceKey'],
                message: 'Fixed row selection sourceKey must be declared in page dataSourceKeys',
            });
        }
    });
    if (appBaseConfig.productMode !== 'app-base')
        return;
    if (!appBaseConfig.databaseBindings) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ['databaseBindings'],
            message: 'App databaseBindings must be declared as the canonical database source',
        });
        return;
    }
    for (const [sourceKey, binding] of Object.entries(appBaseConfig.databaseBindings)) {
        if (!exports.AppBaseDataSourceRoleSchema.safeParse(binding.role).success) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                path: ['databaseBindings', sourceKey, 'role'],
                message: 'App database binding role must be a known App data source role',
            });
        }
        if (!exports.AppBaseContentModelSchema.safeParse(binding.contentModel).success) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                path: ['databaseBindings', sourceKey, 'contentModel'],
                message: 'App database binding contentModel must be a known App content model',
            });
        }
    }
}
function withDerivedDataSources(appBaseConfig) {
    const { dataSources: _dataSources, ...storedConfig } = appBaseConfig;
    const configWithDerivedDataSources = storedConfig;
    Object.defineProperty(configWithDerivedDataSources, 'dataSources', {
        configurable: false,
        enumerable: false,
        get: () => projectAppBaseDatabaseBindingDataSources(storedConfig.databaseBindings),
    });
    return configWithDerivedDataSources;
}
function stripRuntimeDataSourcesProjection(input) {
    if (!input || typeof input !== 'object' || Array.isArray(input))
        return input;
    const record = input;
    if ('dataSources' in record &&
        !Object.prototype.propertyIsEnumerable.call(record, 'dataSources')) {
        return Object.fromEntries(Object.entries(record).filter(([key]) => key !== 'dataSources'));
    }
    return input;
}
/**
 * App Containers saved before the lifecycle log was dropped still carry
 * `appBaseLifecycle.operations`. Reading drops it, so the next save writes the
 * smaller settings cell; the audit events of each change keep that history.
 */
function stripRetiredLifecycleOperations(input) {
    if (!input || typeof input !== 'object' || Array.isArray(input))
        return input;
    const lifecycle = input.appBaseLifecycle;
    if (!lifecycle ||
        typeof lifecycle !== 'object' ||
        Array.isArray(lifecycle) ||
        !('operations' in lifecycle)) {
        return input;
    }
    const { operations: _retired, ...rest } = lifecycle;
    return { ...input, appBaseLifecycle: rest };
}
/** AppBase configuration: see APP_BASE_PLATFORM_AUTHORING_GUIDE.terminology. */
exports.AppBaseConfigSchema = zod_1.z
    .preprocess(input => stripRetiredLifecycleOperations(stripRuntimeDataSourcesProjection(input)), AppBaseConfigShapeSchema)
    .superRefine(validateAppBaseDataSourceProjection)
    .transform(withDerivedDataSources);
/**
 * Fields that used to live inline on {@link AppBaseConfig} but now belong to a
 * dedicated standard database. A persisted payload carrying any of these
 * fields is a sign of stale data and must be re-authored against the new
 * styling databases — no backfill, no silent migration.
 */
exports.DEPRECATED_APP_BASE_CONFIG_BLOB_FIELDS = [
    'motion',
    'styles',
    'styleVariants',
    'forms',
];
class BlobConfigDeprecatedError extends Error {
    constructor(fields) {
        super(`AppBaseConfig carries deprecated blob field(s): ${fields.join(', ')}. Motion specs / style presets / style variants live in dedicated standard databases since sl-sbux.8.2 — re-author the affected app instead of patching the blob.`);
        this.name = 'BlobConfigDeprecatedError';
        this.fields = fields;
    }
}
exports.BlobConfigDeprecatedError = BlobConfigDeprecatedError;
/**
 * Throw if `raw` carries any of the deprecated blob fields. Call this BEFORE
 * `AppBaseConfigSchema.parse(raw)` so the failure surfaces at the persistence
 * boundary rather than being silently stripped by Zod.
 */
function validateNoDeprecatedBlobFields(raw) {
    if (!raw || typeof raw !== 'object')
        return;
    const offenders = [];
    for (const field of exports.DEPRECATED_APP_BASE_CONFIG_BLOB_FIELDS) {
        if (field in raw) {
            offenders.push(field);
        }
    }
    if (offenders.length > 0) {
        throw new BlobConfigDeprecatedError(offenders);
    }
}
/**
 * `sourceFiles` is row-owned materialization state. Drafts, snapshots and
 * install responses strip it, so every writer of a ViewConfig row keeps the
 * row's mapping unless the next config sets one explicitly.
 */
function withRowOwnedAppBaseState(next, current) {
    if (next.sourceFiles || !current?.sourceFiles)
        return next;
    return { ...next, sourceFiles: current.sourceFiles };
}
/**
 * The empty start page a new App Container shows at `rootRoutePath` until an
 * App is mounted there. Mounting an App at that place replaces it; a page
 * that reads data or belongs to an App is never replaceable.
 */
function isReplaceableAppPlaceholderPage(appBaseConfig, page, rootRoutePath) {
    const root = (0, app_base_contract_1.normalizeAppRoutePath)(rootRoutePath);
    const isOwnedByEmptyShell = appBaseConfig.appArtifact?.routeModules.some(module => module.id === 'shell' &&
        module.dataSourceKeys.length === 0 &&
        module.actionIds.length === 0 &&
        (0, app_base_contract_1.normalizeAppRoutePath)(module.rootRoutePath) === root &&
        module.routePaths.some(routePath => (0, app_base_contract_1.normalizeAppRoutePath)(routePath) === root)) ?? false;
    return (appBaseConfig.productMode === 'app-base' &&
        (0, app_base_contract_1.normalizeAppRoutePath)(page.path) === root &&
        page.routeKind === 'custom' &&
        (page.templateKey === 'app-base' || isOwnedByEmptyShell) &&
        page.dataSourceKeys.length === 0);
}
/** The manifest route of that empty start page. */
function isReplaceableAppPlaceholderRoute(route, rootRoutePath) {
    return ((0, app_base_contract_1.normalizeAppRoutePath)(route.path) ===
        (0, app_base_contract_1.normalizeAppRoutePath)(rootRoutePath) &&
        route.entry === 'index.html' &&
        route.dataSourceKeys.length === 0);
}
/**
 * Canonical, side-effect free impact projection for removing one App.
 * A database binding is removed from the app only when this mount is its sole
 * consumer and the database was created for the app. Attached or shared
 * resources are always retained.
 */
function planAppRemoval(appBaseConfig, mountId) {
    const composition = appBaseConfig.appComposition;
    const mount = composition?.mounts.find(item => item.mountId === mountId);
    if (!mount)
        throw new Error(`App Module mount ${mountId} not found`);
    const definition = appBaseConfig.appDefinitions[mount.appId];
    if (!definition) {
        throw new Error(`App Module definition ${mount.appId} not found`);
    }
    const output = (0, app_base_contract_1.compileAppMount)({ definition, mount });
    const removedRoutePaths = new Set(output.routes.map(route => route.path));
    const otherSourceKeys = new Set();
    for (const otherMount of composition?.mounts ?? []) {
        if (otherMount.mountId === mountId)
            continue;
        const otherDefinition = appBaseConfig.appDefinitions[otherMount.appId];
        if (!otherDefinition)
            continue;
        const otherOutput = (0, app_base_contract_1.compileAppMount)({
            definition: otherDefinition,
            mount: otherMount,
        });
        for (const sourceKey of otherOutput.dataSourceKeys) {
            otherSourceKeys.add(sourceKey);
        }
    }
    for (const page of appBaseConfig.pages) {
        if (removedRoutePaths.has(page.path))
            continue;
        for (const sourceKey of page.dataSourceKeys)
            otherSourceKeys.add(sourceKey);
    }
    const resourceLabels = new Map(output.resources.map(resource => [
        resource.sourceKey,
        resource.label ??
            appBaseConfig.databaseBindings[resource.sourceKey]?.label ??
            resource.sourceKey,
    ]));
    const removedDataSources = [];
    const retainedDataSources = [];
    for (const sourceKey of output.dataSourceKeys) {
        const binding = appBaseConfig.databaseBindings[sourceKey];
        if (!binding || binding.status !== 'active')
            continue;
        const label = resourceLabels.get(sourceKey) ?? binding.label;
        if (binding.ownership === 'app-base-owned' &&
            !otherSourceKeys.has(sourceKey)) {
            removedDataSources.push({
                sourceKey,
                label,
                reason: 'exclusive-owned',
            });
        }
        else {
            retainedDataSources.push({
                sourceKey,
                label,
                reason: binding.ownership === 'attached-existing'
                    ? 'attached-existing'
                    : 'shared',
            });
        }
    }
    return {
        mountId,
        appId: mount.appId,
        title: definition.title,
        routePaths: output.routes.map(route => route.path),
        actionLabels: output.actions.map(action => action.label),
        removedDataSources,
        retainedDataSources,
    };
}
/**
 * What deleting an App in the trash for good removes: its removed mount is
 * planned as if it were still in place, so its exclusive tables lose their
 * binding like on a removal before the trash.
 */
function planTrashedAppRemoval(appBaseConfig, appId) {
    const trash = appBaseConfig.appDefinitions[appId]?.trash;
    if (!trash)
        throw new Error(`App Module ${appId} is not in the trash`);
    const composition = appBaseConfig.appComposition;
    if (!composition)
        throw new Error('App has no composition');
    return planAppRemoval({
        ...appBaseConfig,
        appComposition: {
            ...composition,
            mounts: [...composition.mounts, trash.mount],
        },
    }, trash.mount.mountId);
}
/**
 * The pages of a container with the tables each works on: the tables of the
 * App page behind it (appPageTables: shown, of the commands it leads, of its
 * Agent Actions), under the keys its mount gives them. A page no App is
 * mounted at works on the tables it shows. Page rights may name only these.
 * Takes the settings of a container or the part a permission reader keeps.
 */
function appPageAccessRoutes(appBaseConfig) {
    const mounts = appBaseConfig.appComposition?.mounts ?? [];
    return (appBaseConfig.appBase?.routes ?? []).map(route => {
        const mount = (0, app_base_contract_1.mountOfRoute)(mounts, route.path);
        const definition = mount
            ? appBaseConfig.appDefinitions[mount.appId]
            : undefined;
        const appPath = mount && definition
            ? (0, app_base_contract_1.unmountAppPath)(mount.routePrefix, route.path)
            : null;
        const page = definition?.routes.find(candidate => (0, app_base_contract_1.normalizeAppRoutePath)(candidate.route.path) === appPath);
        return {
            path: route.path,
            dataSourceKeys: mount && definition && page
                ? [
                    ...new Set((0, app_page_access_1.appPageTables)(definition, page).map(sourceKey => (0, app_base_contract_1.mountedAppSourceKey)(mount, sourceKey))),
                ]
                : [...route.dataSourceKeys],
        };
    });
}
function sanitizeAppManifestForMarketplaceExport(manifest) {
    return (0, app_base_contract_1.withAppBaseInteractionContract)({
        ...manifest,
        actions: manifest.actions.map(action => {
            if (action.type !== 'automationRun')
                return action;
            const { automationId: _automationId, workflowId: _workflowId, ...templateAction } = action;
            return templateAction;
        }),
    });
}
function sanitizeAppBaseConfigForMarketplaceAppExport(appBaseConfig) {
    const appBase = appBaseConfig.appBase
        ? sanitizeAppManifestForMarketplaceExport(appBaseConfig.appBase)
        : undefined;
    const appArtifact = appBaseConfig.appArtifact
        ? app_base_contract_1.AppArtifactSchema.parse({
            ...appBaseConfig.appArtifact,
            manifest: sanitizeAppManifestForMarketplaceExport(appBaseConfig.appArtifact.manifest),
        })
        : undefined;
    return exports.AppBaseConfigSchema.parse({
        ...appBaseConfig,
        appBase,
        appArtifact,
        appBaseLifecycle: undefined,
    });
}
function createDefaultDataSourceRef(input) {
    return exports.DataSourceRefSchema.parse({
        version: exports.DATA_SOURCE_REF_SCHEMA_VERSION,
        ...input,
    });
}
function createAppBaseDatabaseBindingsFromDataSources(dataSources) {
    const now = '1970-01-01T00:00:00.000Z';
    return Object.fromEntries(Object.entries(dataSources).map(([sourceKey, ref]) => [
        sourceKey,
        (0, app_base_contract_1.createAppBaseDatabaseBinding)({
            sourceKey,
            semanticKey: ref.semanticKey,
            role: ref.role,
            contentModel: ref.contentModel,
            databaseId: ref.databaseId,
            docId: ref.docId,
            blockId: ref.blockId,
            label: ref.label,
            ownership: 'app-base-owned',
            now,
        }),
    ]));
}
function removeString(values, value) {
    return values.filter(current => current !== value);
}
function dataSourceFromDatabaseBinding(binding) {
    return createDefaultDataSourceRef({
        key: binding.sourceKey,
        semanticKey: binding.semanticKey === binding.sourceKey
            ? undefined
            : binding.semanticKey,
        role: exports.AppBaseDataSourceRoleSchema.parse(binding.role),
        contentModel: exports.AppBaseContentModelSchema.parse(binding.contentModel),
        databaseId: binding.databaseId,
        docId: binding.placement.docId,
        blockId: binding.placement.blockId,
        label: binding.label,
    });
}
function projectAppBaseDatabaseBindingDataSources(bindings) {
    const activeEntries = Object.entries(bindings ?? {}).filter(([, binding]) => binding.status === 'active');
    if (activeEntries.length === 0)
        return {};
    return Object.fromEntries(activeEntries.map(([sourceKey, binding]) => [
        sourceKey,
        dataSourceFromDatabaseBinding(binding),
    ]));
}
/**
 * App resources that declare the table behind `sourceKey`, after each
 * mount's binding remap. `appId` narrows the search to one App.
 */
function listAppBaseSourceDeclarations(input) {
    const { appBaseConfig: config, sourceKey, appId } = input;
    return (config.appComposition?.mounts ?? []).flatMap(mount => {
        if (appId && mount.appId !== appId)
            return [];
        const definition = config.appDefinitions[mount.appId];
        if (!definition)
            return [];
        return definition.resources
            .filter(resource => (mount.bindings[resource.sourceKey]?.targetSourceKey ??
            resource.sourceKey) === sourceKey)
            .map(resource => ({ definition, resource }));
    });
}
/**
 * Whether the app can hold the table behind `sourceKey`: it is already bound,
 * or exactly one declared App owns it and a new table can be created.
 */
function canProvisionAppBaseSource(appBaseConfig, sourceKey) {
    if (appBaseConfig.databaseBindings?.[sourceKey]?.status === 'active') {
        return true;
    }
    const owners = new Set(listAppBaseSourceDeclarations({ appBaseConfig, sourceKey }).map(declaration => declaration.definition.appId));
    return owners.size === 1;
}
/**
 * The Agent Action a rowGroupInsert action of the manifest runs, and every
 * table that Agent Action is bound to. Null when the manifest has no such
 * action, or the App that owns it is not mounted any more.
 */
function resolveAppBaseRowGroupInsertTarget(appBaseConfig, actionId) {
    const manifest = appBaseConfig.appBase;
    const action = manifest?.actions.find(candidate => candidate.id === actionId);
    if (action?.type !== 'rowGroupInsert')
        return null;
    const { mountId } = (0, app_base_contract_1.resolveAppDelivery)(manifest, { actionId });
    const mount = appBaseConfig.appComposition?.mounts.find(candidate => candidate.mountId === mountId);
    if (!mount)
        return null;
    const agentAction = appBaseConfig.appDefinitions[mount.appId]?.agentActions.find(candidate => candidate.id === action.agentActionId);
    if (!agentAction)
        return null;
    return {
        appId: mount.appId,
        agentActionId: agentAction.id,
        contract: agentAction.contract,
        tables: agentAction.bindings.map(binding => ({
            bindingKey: binding.bindingKey,
            sourceKey: mount.bindings[binding.sourceKey]?.targetSourceKey ?? binding.sourceKey,
            accessMode: binding.accessMode,
            columnIds: binding.allowedColumnIds,
        })),
    };
}
/**
 * Why a binding does not carry one table of a rowGroupInsert action, or null
 * where it does. A written table needs every column released; whether the
 * person may write it is the right of the page.
 */
function appBaseRowGroupInsertTableDenial(binding, table) {
    const writes = table.accessMode === 'WRITE';
    if (!binding || binding.status !== 'active') {
        return { reason: 'unavailable', columnIds: [] };
    }
    if (writes && binding.exposure.columnIds.length === 0) {
        return { reason: 'no-column-allowlist', columnIds: [] };
    }
    const released = new Set(binding.exposure.columnIds);
    const columnIds = table.columnIds
        .map(columnId => (0, app_base_column_map_1.toTargetColumnId)(binding, columnId))
        .filter(columnId => !released.has(columnId));
    return columnIds.length > 0 ? { reason: 'columns', columnIds } : null;
}
/**
 * What an action does with each table it works on; the page it is used on
 * rules each by its rights. An automation works on none.
 */
function appActionTableOperations(appBaseConfig, action) {
    switch (action.type) {
        case 'rowInsert':
            return [{ sourceKey: action.sourceKey, operation: 'create' }];
        case 'attachmentUpdate':
            return [
                {
                    sourceKey: action.sourceKey,
                    operation: action.mode === 'newRow' ? 'create' : 'update',
                },
            ];
        case 'ownRowChange':
            return [{ sourceKey: action.sourceKey, operation: action.operation }];
        case 'rowGroupInsert':
            return (resolveAppBaseRowGroupInsertTarget(appBaseConfig, action.id)?.tables ??
                []).map(table => ({
                sourceKey: table.sourceKey,
                operation: table.accessMode === 'WRITE' ? 'create' : 'read',
            }));
        case 'automationRun':
            return [];
    }
}
/** A group of rows whose App no longer declares it works on no table it
 * could name: nobody may use it. */
function appRowGroupWithoutTarget(appBaseConfig, action) {
    return (action.type === 'rowGroupInsert' &&
        resolveAppBaseRowGroupInsertTarget(appBaseConfig, action.id) === null);
}
/** A command only the host of its App runs (its file call), never a page. */
function appActionHostOnly(action) {
    return action.type === 'attachmentUpdate' && action.hostOnly === true;
}
/**
 * The decision on a command the host of its App runs without a page, as the
 * agent tool runtime runs an Agent Action: for the workspace member of the
 * call, whatever the delivery of the App. A visitor signs in, nobody else
 * acts, and a command of the pages never runs this way.
 */
function appActionHostDecision(input) {
    if (!appActionHostOnly(input.action))
        return { entry: 'denied' };
    if (input.principalType === 'anonymous')
        return { entry: 'signIn' };
    return input.principalType === 'workspaceMember'
        ? { entry: 'open', principalType: 'workspaceMember' }
        : { entry: 'denied' };
}
/** Without a page only workspace members act, and only in an App that signs in. */
function appActionWithoutPageAllowed(input) {
    return (input.principalType === 'workspaceMember' &&
        input.appBaseConfig.appBase !== undefined &&
        (0, app_base_contract_1.appBaseAudienceFactsForProfile)((0, app_base_contract_1.resolveAppExposureProfile)(input.appBaseConfig.appBase, {
            actionId: input.action.id,
        })).signsIn);
}
/** A signed-in portal person adds rows on a public page as itself. */
function appPagePublicActsAsPortal(principal, operations) {
    return (principal.kind === 'portal' &&
        operations.some(operation => operation === 'create') &&
        operations.every(operation => operation === 'create' || operation === 'read'));
}
/** The one page decision on an action; the server enforces it and the Dev
 * Kit shows it. */
function appPageActionDecision(input) {
    if (appActionHostOnly(input.action) ||
        appRowGroupWithoutTarget(input.appBaseConfig, input.action))
        return { entry: 'denied' };
    const tables = appActionTableOperations(input.appBaseConfig, input.action);
    const page = (0, app_page_access_1.resolveAppPageAccess)({
        section: input.appBaseConfig.pageAccess,
        routePath: input.routePath,
        sourceKeys: tables.map(table => table.sourceKey),
        principal: input.principal,
    });
    if (page.entry === 'signIn')
        return { entry: 'signIn' };
    if (page.entry === 'denied' ||
        tables.some(table => (0, app_page_access_1.appPageTableRowScope)(page.tables[table.sourceKey], table.operation) ===
            null))
        return { entry: 'denied' };
    if (page.actsAs === 'internal')
        return {
            entry: 'open',
            actsAs: 'internal',
            principalType: 'workspaceMember',
        };
    if (page.actsAs === 'portal')
        return { entry: 'open', actsAs: 'portal', principalType: 'portal' };
    return {
        entry: 'open',
        actsAs: 'public',
        principalType: appPagePublicActsAsPortal(input.principal, tables.map(table => table.operation))
            ? 'portal'
            : 'anonymous',
    };
}
/**
 * The widest principal type that may use an action: a page open to
 * visitors, then portal persons, then members; else the way without a
 * page. Automations only go the way without a page. null when nobody may.
 */
function appActionWidestPrincipalType(input) {
    const { appBaseConfig, action } = input;
    if (appRowGroupWithoutTarget(appBaseConfig, action))
        return null;
    if (action.type !== 'automationRun') {
        const principals = [
            { kind: 'visitor' },
            { kind: 'portal', groupIds: [] },
            { kind: 'member', groupIds: [], role: 'write' },
        ];
        for (const principal of principals) {
            for (const route of appBaseConfig.appBase?.routes ?? []) {
                const decision = appPageActionDecision({
                    appBaseConfig,
                    action,
                    routePath: route.path,
                    principal,
                });
                if (decision.entry === 'open')
                    return decision.principalType;
            }
        }
    }
    return appActionWithoutPageAllowed({
        appBaseConfig,
        action,
        principalType: 'workspaceMember',
    })
        ? 'workspaceMember'
        : null;
}
function withAppBaseDatabaseBinding(input) {
    const { appBaseConfig, binding } = input;
    const databaseBindings = {
        ...(appBaseConfig.databaseBindings ?? {}),
        [binding.sourceKey]: binding,
    };
    // A bound source no longer waits for approval.
    const { [binding.sourceKey]: _bound, ...pendingDatabaseAttachments } = appBaseConfig.pendingDatabaseAttachments ?? {};
    return exports.AppBaseConfigSchema.parse({
        ...appBaseConfig,
        productMode: appBaseConfig.productMode ?? input.defaultProductMode ?? 'app-base',
        databaseBindings,
        pendingDatabaseAttachments: Object.keys(pendingDatabaseAttachments).length
            ? pendingDatabaseAttachments
            : undefined,
    });
}
/**
 * Names a workspace table an install may not bind under the App source key
 * it would have bound; see {@link AppBasePendingDatabaseAttachmentSchema}.
 */
function withPendingDatabaseAttachment(input) {
    return exports.AppBaseConfigSchema.parse({
        ...input.appBaseConfig,
        pendingDatabaseAttachments: {
            ...(input.appBaseConfig.pendingDatabaseAttachments ?? {}),
            [input.sourceKey]: input.attachment,
        },
    });
}
function withoutAppBaseDatabaseBinding(input) {
    const { appBaseConfig, sourceKey, binding } = input;
    const { [sourceKey]: _removedBinding, ...existingBindings } = appBaseConfig.databaseBindings ?? {};
    const databaseBindings = {
        ...existingBindings,
        [sourceKey]: (0, app_base_contract_1.bumpAppBaseDatabaseBindingRevision)(binding, {
            status: 'detached',
            now: input.now,
        }),
    };
    return exports.AppBaseConfigSchema.parse({
        ...appBaseConfig,
        databaseBindings,
        pages: appBaseConfig.pages.map(page => ({
            ...page,
            dataSourceKeys: removeString(page.dataSourceKeys, sourceKey),
        })),
    });
}
function withMovedAppBaseDatabaseBinding(input) {
    const movedBinding = (0, app_base_contract_1.bumpAppBaseDatabaseBindingRevision)(input.binding, {
        status: 'active',
        placement: {
            docId: input.docId,
            blockId: input.blockId,
        },
        now: input.now,
    });
    return withAppBaseDatabaseBinding({
        appBaseConfig: input.appBaseConfig,
        binding: movedBinding,
    });
}
function createDefaultAppBaseConfig(input) {
    const productMode = input.productMode ?? 'app-base';
    const databaseBindings = createAppBaseDatabaseBindingsFromDataSources(input.dataSources);
    const dataSources = projectAppBaseDatabaseBindingDataSources(databaseBindings);
    const sourceKeys = Object.keys(dataSources);
    return exports.AppBaseConfigSchema.parse({
        schemaVersion: exports.APP_BASE_CONFIG_SCHEMA_VERSION,
        productMode,
        defaultLocale: input.defaultLocale ?? app_base_locales_1.APP_BASE_DEFAULT_LOCALE,
        availableLocales: [input.defaultLocale ?? app_base_locales_1.APP_BASE_DEFAULT_LOCALE],
        databaseBindings,
        pages: [
            {
                id: 'home',
                routeKind: 'static',
                templateKey: 'landing',
                collectionRole: null,
                publicationModel: 'evergreen',
                status: 'published',
                path: '/',
                parentPageId: null,
                order: 0,
                titleFormula: { type: 'value', value: input.title },
                dataSourceKeys: sourceKeys,
                navigationKey: null,
                i18nPolicy: content_i18n_1.DEFAULT_CONTENT_I18N_POLICY,
            },
        ],
        navigation: [],
        i18nPolicy: content_i18n_1.DEFAULT_CONTENT_I18N_POLICY,
        stripImageMetadata: true,
    });
}
function createAppBaseConfigFromContentDbRef(input) {
    if (!input.contentDbRef)
        return undefined;
    const appBaseConfig = createDefaultAppBaseConfig({
        title: input.name,
        defaultLocale: input.defaultLocale,
        productMode: input.productMode,
        dataSources: {
            [exports.APP_BASE_DATA_SOURCE_KEYS.CONTENT]: createDefaultDataSourceRef({
                key: exports.APP_BASE_DATA_SOURCE_KEYS.CONTENT,
                role: 'content',
                contentModel: input.contentDbRef.contentModel,
                databaseId: input.contentDbRef.databaseId,
                docId: input.contentDbRef.docId,
                blockId: input.contentDbRef.blockId,
                label: 'Content',
            }),
        },
    });
    return exports.AppBaseConfigSchema.parse({
        ...appBaseConfig,
        pages: appBaseConfig.pages.map(page => page.path === '/'
            ? {
                ...page,
                templateKey: 'custom',
                collectionRole: null,
                dataSourceKeys: [exports.APP_BASE_DATA_SOURCE_KEYS.CONTENT],
                navigationKey: null,
            }
            : page),
    });
}
function resolveDataSourceRegistry(input) {
    if (input.appBaseConfig) {
        const dataSources = resolveAppBaseBindingDataSources(input.appBaseConfig);
        if (Object.keys(dataSources).length > 0)
            return dataSources;
    }
    if (!input.contentDbRef)
        return {};
    return {
        [exports.APP_BASE_DATA_SOURCE_KEYS.CONTENT]: createDefaultDataSourceRef({
            key: exports.APP_BASE_DATA_SOURCE_KEYS.CONTENT,
            role: 'content',
            contentModel: input.contentDbRef.contentModel,
            databaseId: input.contentDbRef.databaseId,
            docId: input.contentDbRef.docId,
            blockId: input.contentDbRef.blockId,
            label: 'Content',
        }),
    };
}
function resolveAppBaseBindingDataSources(appBaseConfig) {
    if (appBaseConfig?.productMode !== 'app-base')
        return {};
    return projectAppBaseDatabaseBindingDataSources(appBaseConfig.databaseBindings);
}
function resolveAppBaseDatabaseBindings(input) {
    return input.appBaseConfig?.databaseBindings ?? {};
}
function createAppBaseAppBaseConfig(input) {
    const appBaseConfig = createDefaultAppBaseConfig({
        title: input.name,
        defaultLocale: input.defaultLocale,
        productMode: 'app-base',
        dataSources: {},
    });
    const appComposition = app_base_contract_1.AppCompositionSchema.parse({
        schemaVersion: 1,
        compositionId: 'app-base-shell',
        revision: 1,
        updatedAt: '1970-01-01T00:00:00.000Z',
        shell: {
            manifestId: input.manifestId ?? 'custom',
            name: input.name,
            entry: 'index.html',
            rootRoutePath: '/',
        },
        mounts: [],
    });
    const compiledArtifact = (0, app_base_contract_1.compileAppComposition)({
        composition: appComposition,
        artifactId: 'app-base-shell',
        now: '1970-01-01T00:00:00.000Z',
    });
    const appArtifact = app_base_contract_1.AppArtifactSchema.parse({
        ...compiledArtifact,
        manifest: (0, app_base_contract_1.withAppBaseInteractionContract)(compiledArtifact.manifest),
    });
    const appBase = appArtifact.manifest;
    return exports.AppBaseConfigSchema.parse({
        ...appBaseConfig,
        appComposition,
        appBase,
        appArtifact,
        pages: appBaseConfig.pages.map(page => ({
            ...page,
            routeKind: 'custom',
            templateKey: 'app-base',
            dataSourceKeys: [],
            navigationKey: null,
        })),
        navigation: [
            {
                id: 'home',
                labelFormula: { type: 'value', value: input.name },
                pageId: 'home',
                href: null,
                parentId: null,
                order: 0,
            },
        ],
    });
}
